import { FileText, LayoutDashboard, LifeBuoy, Users } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ErrorState } from '@/components/error-state';
import { useTranslation } from '../../i18n/useTranslation';

type NotFoundPageProps = {
  variant?: 'in-layout' | 'standalone';
};

export function NotFoundPage({ variant = 'standalone' }: NotFoundPageProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  function handleGoBack() {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  }

  return (
    <ErrorState
      code="404"
      accent="blue"
      eyebrow={t('notFound.eyebrow')}
      title={t('notFound.title')}
      description={t('notFound.description')}
      primaryAction={{ label: t('notFound.back'), onClick: handleGoBack }}
      secondaryAction={{
        label: t('notFound.dashboard'),
        href: '/dashboard',
      }}
      helpTitle={t('notFound.helpTitle')}
      helpLinks={[
        {
          href: '/dashboard',
          label: t('notFound.links.dashboard.label'),
          description: t('notFound.links.dashboard.description'),
          icon: <LayoutDashboard aria-hidden="true" />,
        },
        {
          href: '/bills',
          label: t('notFound.links.invoices.label'),
          description: t('notFound.links.invoices.description'),
          icon: <FileText aria-hidden="true" />,
        },
        {
          href: '/clients',
          label: t('notFound.links.clients.label'),
          description: t('notFound.links.clients.description'),
          icon: <Users aria-hidden="true" />,
        },
        {
          href: '/support',
          label: t('notFound.links.support.label'),
          description: t('notFound.links.support.description'),
          icon: <LifeBuoy aria-hidden="true" />,
        },
      ]}
      variant={variant}
    />
  );
}
